angular.module('unergie.main')
.controller('newManagedAccountModalCtrl', ($scope, $uibModal, $uibModalInstance, DataAccess, AlertManager, DataAccessSearch, TogglerUtils, ApiUser,
    OrganizationService, DataAccessReferences, ReferencesService, ErrorCatcher) => {
    $scope.CUSTOMER_ID_PATTERN = /^CL\w{7}$/
    $scope.isPlum = TogglerUtils.isPlum()
    $scope.payload = {
        billingAccount: {},
        contacts: [],
    }
    $scope.creating = false

    OrganizationService.getOrgz().then((organizations) => {
        $scope.orgz = _.orderBy(_.map(_.filter(organizations, (org) => ['B2B', 'B2G'].includes(org.type)), (d) => ({ label: d.id, value: d.id, type: d.type })), 'label')
    })

    ReferencesService.getRef('id-grd-contracts', true).then((mapping) => {
        $scope.grdContracts = _.map(mapping, (m) => ({ label: m.id, value: m.id }))
    })

    ReferencesService.getRef('inseepostcode', true).then((mapping) => {
        $scope.postcodes = _.uniq(_.map(mapping, 'postcode'))
    })

    $scope.postcodeValid = () => {
        return $scope.postcodes && $scope.postcodes.includes($scope.payload.billingAccount.addr_post_code)
    }

    const normalize = (string) => {
        return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^.\w]/gi, '_').toLowerCase().slice(0, 64)
    }

    $scope.updateMail = () => {
        $scope.payload.mail = `${normalize($scope.payload.brand || '')}@${$scope.payload.organization || ''}.fr`
    }

    $scope.addressComplete = () => {
        return !!$scope.payload.billingAccount.addr_num_street && !!$scope.payload.billingAccount.addr_city_lbl && !!$scope.payload.billingAccount.addr_post_code
    }

    $scope.updateOrg = () => {
        $scope.updateMail()
        if ($scope.payload.id_grd_contract) {
            return DataAccessSearch({ offset: 0 })
            .count({ resource: 'accounts', organization: $scope.payload.organization, id_grd_contract: $scope.payload.id_grd_contract, groups: 'managed-account' }).$promise
            .then((data) => {
                $scope.existingAccounts = data.count
                $scope.isB2B = _.find($scope.orgz, { value: $scope.payload.organization }).type === 'B2B'
            })
        }
    }

    $scope.canCreate = () => {
        return !!$scope.payload.billingAccount.addr_num_street &&
            !!$scope.payload.billingAccount.addr_city_lbl &&
            !!$scope.payload.billingAccount.addr_post_code && $scope.postcodeValid() &&
            !!$scope.payload.brand &&
            !!$scope.payload.organization &&
            !!$scope.payload.mail &&
            !!$scope.payload.id_grd_contract &&
            (!$scope.overrideCustomerId || $scope.payload.customer_id) &&
            _.every($scope.payload.contacts, (contact) => !!contact.civ &&
                !!contact.givenname &&
                !!contact.sn &&
                !!contact.mail)
    }

    $scope.createAccount = () => {
        $scope.creating = true
        const query = {
            autoGenerateId: $scope.existingAccounts === 0 && !$scope.overrideCustomerId,
        }
        const payload = _.assign({}, _.pickBy($scope.payload), { billingAccount: _.pickBy($scope.payload.billingAccount) })
        return DataAccess.createManagedAccount(query, payload).$promise.then((result) => {
            AlertManager.success('Compte de facturation créé')
            $uibModalInstance.close()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.creating = false
        })
    }

    $scope.lookupAddr = function (addr) {
        $scope.coordinates = undefined
        $scope.searching = true
        return ApiUser.lookupStrictAddr({ q: addr }).$promise
        .finally(() => {
            $scope.searching = false
        })
    }

    $scope.updateAddress = function (data) {
        $scope.payload.billingAccount.addr_num_street = data.addr_num_street
        $scope.payload.billingAccount.addr_city_lbl = data.addr_city_lbl && data.addr_city_lbl.toUpperCase()
        $scope.payload.billingAccount.addr_post_code = data.addr_post_code
    }

    $scope.close = () => $uibModalInstance.close()
})
